{
  "audio": {
    "tempo": {
      "noteDuration": 0.3,
      "noteGap": 0.2,
      "description": "Duration of each note and gap between notes in seconds"
    },
    "pitch": {
      "startingPitch": 60,
      "description": "Starting MIDI note number (60 = Middle C)"
    }
  },
  "visual": {
    "highlighting": {
      "color": "#ff6b35",
      "description": "Color for note highlighting during playback"
    },
    "intervals": {
      "bracketMargins": {
        "bottomOffset": 30,
        "topOffset": 24,
        "description": "Distance from staff bottom: bottomOffset for brackets, topOffset for text (both relative to stave bottom)"
      },
      "bracketSpacing": {
        "curveHeight": 4.8,
        "curveControl": 4.8,
        "description": "Height and control point offset for curly bracket curves"
      },
      "color": "#a5998c",
      "description": "Color for interval brackets and numbers",
      "highlighting": {
        "enabled": true,
        "dimOpacity": 0.3,
        "highlightStrokeWidth": 3,
        "transitionDuration": "0.2s",
        "description": "Settings for interval note highlighting on hover/tap. Set enabled to false to disable."
      }
    },
    "layout": {
      "scaleHeaderSpacing": 0.4,
      "description": "Space between Scale# title and staff (in rem)"
    },
    "notation": {
      "containerMargin": 20,
      "staveMargin": 20,
      "staveLeftOffset": 0,
      "staveTopOffset": -20,
      "svgHeight": 120,
      "maxWidth": 460,
      "formatWidth": 360,
      "description": "Layout values for VexFlow notation rendering - ensure margins don't cause overflow. staveLeftOffset aligns with left edge, staveTopOffset controls gap from title."
    },
    "filters": {
      "noteCount": {
        "defaultMin": 4,
        "defaultMax": 12,
        "description": "Default range for note count filter (not including octave)"
      }
    },
    "animation": {
      "noteGlowScale": 1.00,
      "glowDuration": "0.5s",
      "shadowIntensity": 3,
      "useGlowOnly": true,
      "description": "Scale factor, duration, and shadow intensity for note highlight animation. Set useGlowOnly to true for no movement."
    }
  },
  "typography": {
    "scaleTitle": {
      "opacity": 0.6,
      "fontSize": "0.85rem",
      "description": "Styling for 'Scale #X' titles"
    },
    "scaleName": {
      "opacity": 0.8,
      "fontSize": "0.9rem",
      "description": "Styling for scale name (e.g., 'Major (Ionian)')"
    }
  }
}